import { action, observable, makeObservable } from 'mobx';
import { createContext, useContext, useEffect } from 'react';

/* eslint-disable */
export enum FooterType {
  LIKES,
  BEAUTY,
  MONEY,
}
/* eslint-enable */

type FooterSpec = {
  type: FooterType;
};

export class FooterSpecs {
  static likes() {
    return { type: FooterType.LIKES };
  }
  static beauty() {
    return { type: FooterType.BEAUTY };
  }
  static money() {
    return { type: FooterType.MONEY };
  }
}

export class FooterState {
  currentSpec: FooterSpec = FooterSpecs.likes();

  constructor() {
    makeObservable(this, {
      currentSpec: observable,
      setCurrent: action,
    });
  }

  setCurrent(spec: FooterSpec) {
    this.currentSpec = spec;
  }
}

const FooterContext = createContext(new FooterState());

export const useFooterState = () => {
  return useContext(FooterContext);
};

export const useFooter = (spec: FooterSpec) => {
  const state = useFooterState();
  useEffect(() => {
    if (spec) {
      state.setCurrent(spec);
    }
  }, [spec]);
};
